/**
 * Live rolling number cho trang live (/xo-so-truc-tiep).
 *
 * Mỗi miền có state riêng biệt (không dùng biến global chung).
 * Tự động bật/tắt theo khung giờ:
 *   MN (southern) : 16:00 – 16:40
 *   MT (central)  : 17:00 – 17:40
 *   MB (northern) : 18:00 – 18:40
 */

const REGIONS = [
  { key: 'mn', type: 'southern-',  prizeKeys: ['9','8','7','6','5','4','3','2','1'], startH: 16, endH: 16, endM: 40 },
  { key: 'mt', type: 'central-',   prizeKeys: ['9','8','7','6','5','4','3','2','1'], startH: 17, endH: 17, endM: 40 },
  { key: 'mb', type: 'northern-',  prizeKeys: ['2','3','4','5','6','7','8','1'],     startH: 18, endH: 18, endM: 40 },
];

/** State riêng cho mỗi region */
const regionState = {};

function initRegionState(key) {
  if (!regionState[key]) {
    regionState[key] = {
      rollingNumbers: [],
      stackNumbers: [],
      stackAllNumbers: [],
      fetchInterval: null,
      active: false,
      generation: 0, // tăng mỗi khi DOM refresh, dùng để hủy animation cũ
    };
  }
  return regionState[key];
}

function isRegionLive(region) {
  const now = new Date();
  const h = now.getHours(), m = now.getMinutes();
  return (h === region.startH && m >= 0) && !(h === region.endH && m >= region.endM);
}

function isAnyRegionLive() {
  return REGIONS.some(isRegionLive);
}

// ─── Animation ─────────────────────────────────────────────────────────────

function animateNumber(el) {
  return new Promise((resolve) => {
    const full = el.dataset.full;
    const len = full.length;

    el.textContent = '_'.repeat(len);

    let index = len - 1;

    function animateDigit() {
      if (index < 0) {
        resolve();
        return;
      }

      const target = full[index];
      let current = 1;

      const spin = setInterval(() => {
        const chars = el.textContent.split('');
        chars[index] = current;
        el.textContent = chars.join('');
        current = current === 9 ? 1 : current + 1;
      }, 80);

      setTimeout(() => {
        clearInterval(spin);
        const chars = el.textContent.split('');
        chars[index] = target;
        el.textContent = chars.join('');
        index--;
        animateDigit();
      }, 600);
    }

    animateDigit();
  });
}

// ─── Animate queue ─────────────────────────────────────────────────────────

async function rollingNumberPlan(st, typePrefix) {
  const gen = st.generation;
  st.stackNumbers.forEach((queue, index) => {
    if (!st.rollingNumbers[index] && queue.length > 0) {
      animateStackQueue(st, queue, index, typePrefix, gen);
    }
  });
}

async function animateStackQueue(st, queue, provinceIndex, typePrefix, gen) {
  st.rollingNumbers[provinceIndex] = true;

  while (queue.length > 0) {
    // Nếu DOM đã refresh (generation thay đổi) → dừng animation cũ
    if (st.generation !== gen) break;

    const item = queue.shift();
    const container = document.querySelectorAll(
      `.${typePrefix} [data-province-index="${provinceIndex}"][data-prize="${item.prize}"]`
    );
    if (!container) break;

    if (container[item.index] && container[item.index].classList.contains('loading')) {
      const el = container[item.index];
      el.classList.remove('loading');
      el.dataset.full = item.number;
      await animateNumber(el);
    }

    await new Promise(r => setTimeout(r, 300));
  }

  // Chỉ reset nếu vẫn cùng generation
  if (st.generation === gen) {
    st.rollingNumbers[provinceIndex] = false;
  }
}

// ─── Fetch ─────────────────────────────────────────────────────────────────

const vars = window.rollingNumberVars || {};
const ajaxUrl = vars.ajax_url || (window.wp_vars && window.wp_vars.ajax_url) || '/wp-admin/admin-ajax.php';

async function wpAjax(action, data = {}) {
  const body = new URLSearchParams({ action, ...data });
  const resp = await fetch(ajaxUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: body.toString(),
  });
  if (!resp.ok) throw new Error('HTTP ' + resp.status);
  const json = await resp.json();
  if (!json.success) throw new Error(json.data?.message || 'Lỗi máy chủ');
  return json.data;
}

// ─── Start/Stop per-region ─────────────────────────────────────────────────

function startRegion(region) {
  const st = initRegionState(region.key);
  if (st.active) return;

  const typePrefix = region.type + 'lottery';
  const loading = document.querySelectorAll(`.${typePrefix} .loading`);
  if (loading.length === 0) return;

  st.active = true;

  const fetchLiveInfo = async () => {
    // Kiểm tra xem còn trong khung giờ không
    if (!isRegionLive(region)) {
      stopRegion(region);
      return;
    }

    // Nếu DOM không còn loading nào → đã xong
    const remaining = document.querySelectorAll(`.${typePrefix} .loading`);
    if (remaining.length === 0) {
      stopRegion(region);
      return;
    }

    try {
      const dataResult = await wpAjax('kqxs_live');
      const totalProvinces = dataResult.total_results || 0;
      let hasUpdates = false;

      for (let i = 0; i < totalProvinces; i++) {
        if (!st.stackNumbers[i]) st.stackNumbers[i] = [];
        if (!st.stackAllNumbers[i]) st.stackAllNumbers[i] = [];
        if (!st.rollingNumbers[i]) st.rollingNumbers[i] = false;

        for (const key of region.prizeKeys) {
          const keyInt = parseInt(key);
          if (dataResult.results[i] && dataResult.results[i].data && dataResult.results[i].data[keyInt]) {
            const prizes = dataResult.results[i].data[keyInt];
            for (let j = 0; j < prizes.length; j++) {
              const number = prizes[j];
              if (!st.stackAllNumbers[i].includes(number)) {
                st.stackNumbers[i].push({ prize: key, number: number, index: j, provinceIndex: i });
                st.stackAllNumbers[i].push(number);
                hasUpdates = true;
              }
            }
          }
        }
      }

      if (hasUpdates) {
        for (let i = 0; i < totalProvinces; i++) {
          if (st.stackNumbers[i] && st.stackNumbers[i].length > 0) {
            st.stackNumbers[i].sort((a, b) => {
              if (a.prize === b.prize) return a.index - b.index;
              return region.prizeKeys.indexOf(a.prize) - region.prizeKeys.indexOf(b.prize);
            });
          }
        }
        rollingNumberPlan(st, typePrefix);
      }
    } catch (err) {
      console.log('[rolling_number]', region.key, err);
    }
  };

  fetchLiveInfo();
  st.fetchInterval = setInterval(fetchLiveInfo, 20000);
}

function stopRegion(region) {
  const st = regionState[region.key];
  if (!st) return;
  if (st.fetchInterval) {
    clearInterval(st.fetchInterval);
    st.fetchInterval = null;
  }
  st.active = false;
}

// ─── Entry point ───────────────────────────────────────────────────────────

/**
 * Khi kqxs-live.js thay thế innerHTML của #kqxs-live-page, tất cả DOM elements
 * cũ bị hủy. Ta cần rebuild stackAllNumbers từ DOM mới (các ô đã có số)
 * để fetchLiveInfo tiếp theo chỉ animate những ô mới.
 */
function rebuildStateFromDOM(region) {
  const st = regionState[region.key];
  if (!st) return;

  const typePrefix = region.type + 'lottery';

  // Tăng generation → các animation cũ sẽ tự dừng
  st.generation++;

  // Reset animation state — old DOM elements are gone
  st.rollingNumbers = [];
  st.stackNumbers = [];
  st.stackAllNumbers = [];

  // Scan DOM: tìm tất cả ô KHÔNG còn .loading (đã có data)
  // Rebuild stackAllNumbers để fetchLiveInfo không animate lại chúng
  region.prizeKeys.forEach(key => {
    const cells = document.querySelectorAll(
      `.${typePrefix} [data-prize="${key}"]`
    );
    cells.forEach(cell => {
      if (!cell.classList.contains('loading')) {
        const full = cell.dataset.full || cell.textContent.trim();
        if (full && /^\d+$/.test(full)) {
          const pIdx = parseInt(cell.dataset.provinceIndex || '0');
          if (!st.stackAllNumbers[pIdx]) st.stackAllNumbers[pIdx] = [];
          st.stackAllNumbers[pIdx].push(full);
        }
      }
    });
  });
}

document.addEventListener('kqxs-live-refreshed', function () {
  REGIONS.forEach(region => {
    const st = regionState[region.key];
    if (st && st.active) {
      rebuildStateFromDOM(region);
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Bật các region đang live ngay khi tải
  REGIONS.forEach(region => {
    if (isRegionLive(region)) {
      startRegion(region);
    }
  });

  // Kiểm tra mỗi 30 giây để tự động bật region mới (VD: user load lúc 16:30,
  // MN đang chạy, đến 17:00 tự bật MT)
  setInterval(() => {
    REGIONS.forEach(region => {
      const st = regionState[region.key];
      const live = isRegionLive(region);

      if (live && (!st || !st.active)) {
        startRegion(region);
      } else if (!live && st && st.active) {
        stopRegion(region);
      }
    });
  }, 30000);
});
